import React from 'react';
import '../gral-stylesheets/navbar.scss';



class Loger extends React.Component {

  render() {
    return (
      <>
        <li className='navbar-right-element-loger'>
          <button
            className='button-login'
            onClick={this.props.loginOpenHandle}
          >
            <h3>Login</h3>
          </button>
        </li>
        <li className='navbar-right-element-loger'>
          <button
            className='button-join'
            onClick={this.props.joinOpenHandle}
          >
            <h3>Join</h3>
          </button>
        </li>
      </>
    )
  }
}

export default Loger;